import React from 'react';

/**
 * PageHeader — 页面统一标题栏
 *
 * @param {string} title       页面标题
 * @param {node|string} description  页面描述（副标题）
 * @param {node}    actions     右侧操作区域（React 节点）
 */
const PageHeader = ({
  title,
  description,
  actions,
}) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: 28,
      flexWrap: 'wrap',
      gap: 16,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{
          fontSize: 26,
          fontWeight: 600,
          color: 'var(--text-primary)',
          margin: 0,
          marginBottom: description ? 4 : 0,
          letterSpacing: '-0.02em',
          fontFamily: 'var(--font-sans)',
          lineHeight: 1.3,
        }}>
          {title}
        </h1>
        {description && (
          <p style={{
            fontSize: 14,
            color: 'var(--text-secondary)',
            margin: 0,
            fontFamily: 'var(--font-sans)',
            lineHeight: 1.6,
          }}>
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          flexShrink: 0,
        }}>
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
